import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Paper, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MinimizeIcon from '@mui/icons-material/Minimize';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import { translations } from './config/languages';

const DialogContainer = styled(motion.div)`
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 350px;
  z-index: 1000;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
`;

const ChatPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  height: 500px;
  overflow: hidden;
  background: #f8f9fa;
`;

const Header = styled.div`
  background-color: #2e3092;
  color: white;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const OnlineDot = styled.div`
  width: 8px;
  height: 8px;
  background-color: #4caf50;
  border-radius: 50%;
  margin-right: 8px;
`;

const HeaderActions = styled.div`
  display: flex;
  gap: 8px;
`;

const ChatDialog = ({ 
  onClose, 
  messages, 
  onNewMessage, 
  onBotResponse,
  allowImageUpload,
  allowMultilineInput,
  language
}) => {
  const t = translations[language];

  return (
    <DialogContainer
      initial={{ opacity: 0, y: 50, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 50, scale: 0.9 }}
      transition={{ duration: 0.2, ease: "easeOut" }}
    >
      <ChatPaper elevation={3}>
        <Header>
          <HeaderTitle>
            <OnlineDot />
            <Typography variant="h6">{t.chatTitle}</Typography>
          </HeaderTitle>
          <HeaderActions>
            <IconButton 
              color="inherit" 
              onClick={onClose} 
              size="small"
              aria-label={t.minimize}
            >
              <MinimizeIcon />
            </IconButton>
            <IconButton 
              color="inherit" 
              onClick={onClose} 
              size="small"
              aria-label={t.close}
            >
              <CloseIcon />
            </IconButton>
          </HeaderActions>
        </Header>
        <ChatMessages messages={messages} language={language} />
        <ChatInput 
          onSendMessage={onNewMessage} 
          onBotResponse={onBotResponse}
          allowImageUpload={allowImageUpload}
          allowMultilineInput={allowMultilineInput}
          language={language}
        />
      </ChatPaper>
    </DialogContainer>
  );
};

export default ChatDialog; 